import { render, staticRenderFns } from "./PatRecordBPage.vue?vue&type=template&id=5e9a8ca5"
import script from "./PatRecordBPage.vue?vue&type=script&lang=js"
export * from "./PatRecordBPage.vue?vue&type=script&lang=js"
import style0 from "./PatRecordBPage.vue?vue&type=style&index=0&id=5e9a8ca5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports